<div #outsideModal class="modal">
    <div #modalBody class="modal-content">
        <div class="modal-header">Liens familiaux</div>
        <div class="modal-body">
            <div class="tableHisto">
                <frg-table [keysBody]="listParent" [keysColumn]="parentColumnTable"
                    tableButton1="assets/icons/trash.svg" (onClick1)="deleteParent($event)"
                    tableButtonNewItem="assets/icons-white/add.svg" [isEdit]="true" (formSubmit)="changeParents($event)"
                    (formCancel)="closeFamilleModal()" [isCenterHeader]="true" [deleteDuringEdit]="true"
                    *ngIf="listParent"></frg-table>
            </div>
        </div>
    </div>
</div>
<div class="modal-background"></div>